import React from "react";
import { useTranslation } from "react-i18next";

const StartFirstText = () => {
  const { t } = useTranslation();
  return (
    <section className="start-first-text section">
      <div className="container">
        <h2>{t("key-company-important-info.title")}</h2>
        <ul>
          <li>{t("key-company-important-info.item1")}</li>
          <li>{t("key-company-important-info.item2")}</li>
          <li>{t("key-company-important-info.item3")}</li>
        </ul>
        <p>{t("key-company-important-info.item4")}</p>
      </div>
    </section>
  );
};

export default StartFirstText;
